{
  "schemaVersion": 1,
  "key": "ocean",
  "name": "Ocean",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home.png"
  },
  "mascot": {
    "home": "mascot/parrotfish.png"
  },
  "tokens": {
    "accent": "#AD81B6"
  }
}
